import { render, staticRenderFns } from "./reanudar_factura.vue?vue&type=template&id=06dda431&scoped=true"
import script from "./reanudar_factura.vue?vue&type=script&lang=js"
export * from "./reanudar_factura.vue?vue&type=script&lang=js"
import style0 from "./reanudar_factura.vue?vue&type=style&index=0&id=06dda431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dda431",
  null
  
)

export default component.exports